import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly storageService = inject(StorageService);
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const includeUrl = request.url.includes('http');
    const token = this.storageService.getGlobalItem<string>('token');

    if (!includeUrl) {
      if (token) {
        const headers = {};
        headers['Authorization'] = `Bearer ${token}`;
        request = request.clone({
          setHeaders: headers,
        });
      }
    }

    return next.handle(request);
  }
}
